import React, { useState } from 'react';

import {
  Box,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import BackSelected from '../../../../assets/img/sinister/car_side_damage/back-selected.svg';
// import Front from '../../../../assets/img/front.png';
// import Back from '../../../../assets/img/back.png';
// import Left from '../../../../assets/img/left.png';
// import Right from '../../../../assets/img/right.png';
// import Windshield from '../../../../assets/img/windshield.png';
// import Back from '../../../../assets/img/back.svg';
// import Front from '../../../../assets/img/front.svg';
// import Left from '../../../../assets/img/left.svg';
// import Right from '../../../../assets/img/right.svg';
// import Windshield from '../../../../assets/img/windshield.svg';
import Back from '../../../../assets/img/sinister/car_side_damage/back.svg';
import FrontSelected from '../../../../assets/img/sinister/car_side_damage/front-selected.svg';
import Front from '../../../../assets/img/sinister/car_side_damage/front.svg';
import LeftSelected from '../../../../assets/img/sinister/car_side_damage/left-selected.svg';
import Left from '../../../../assets/img/sinister/car_side_damage/left.svg';
import RightSelected from '../../../../assets/img/sinister/car_side_damage/right-selected.svg';
import Right from '../../../../assets/img/sinister/car_side_damage/right.svg';
import WindshieldSelected from '../../../../assets/img/sinister/car_side_damage/windshield-selected.svg';
import Windshield from '../../../../assets/img/sinister/car_side_damage/windshield.svg';
import FloatingButton from '../../../../components/FloatingButton';
import SuraCard from '../../../../components/SuraCard';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    selectionCard: {
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      cursor: 'pointer',

      '& img': {
        height: '60px',
      },
    },
    borderedCard: {
      border: '1px solid #FA6400',
    },
    check: {
      position: 'absolute',
      top: '5%',
      right: '5%',
    },
    checked: {
      '& path': {
        stroke: '#FA6400',
      },
    },
  })
);

const Part = (props: any) => {
  const { title, img, onChange, checked } = props;
  const classes = useStyle();
  const [selected, setSelected] = useState(checked);

  const selectCard = () => {
    onChange(!selected);
    setSelected(!selected);
  };

  const cardStyles =
    classes.selectionCard + (selected ? ' ' + classes.borderedCard : '');
  const checkStyles = classes.check + ' ' + classes.checked;
  // const checkStyles = classes.check + (selected ? ' ' + classes.checked : '');

  const selectedArray = [
    { name: 'back', img: BackSelected },
    { name: 'front', img: FrontSelected },
    { name: 'left', img: LeftSelected },
    { name: 'right', img: RightSelected },
    { name: 'windshield', img: WindshieldSelected },
  ];
  const imagen = selected
    ? selectedArray.filter((e) => `${img}`.toLowerCase().includes(e.name))[0]
        .img
    : img;

  return (
    <Box m={1} onClick={selectCard}>
      <SuraCard className={cardStyles}>
        <Box p={3}>
          {/* <img src={img} alt="part" /> */}
          <img src={imagen} alt="part" />
          <Typography align="center">{title}</Typography>
        </Box>

        <OkIcon className={checkStyles} />
      </SuraCard>
    </Box>
  );
};

const TypeOfOwnDamage = () => {
  const { nextStep, updateSinisterBody, sinister_body } =
    useSinisterDataContext();

  const [state, setState] = useState<any>({
    front:
      sinister_body?.crash?.damaged_parts?.findIndex(
        (side: any) => side.side === 'front'
      ) >= 0 || false,
    back:
      sinister_body?.crash?.damaged_parts?.findIndex(
        (side: any) => side.side === 'back'
      ) >= 0 || false,
    left:
      sinister_body?.crash?.damaged_parts?.findIndex(
        (side: any) => side.side === 'left'
      ) >= 0 || false,
    right:
      sinister_body?.crash?.damaged_parts?.findIndex(
        (side: any) => side.side === 'right'
      ) >= 0 || false,
    windshield:
      sinister_body?.crash?.damaged_parts?.findIndex(
        (side: any) => side.side === 'windshield'
      ) >= 0 || false,
  });

  const handleCheckboxChange = (name: string) => (value: boolean) => {
    setState({ ...state, [name]: value });
  };

  const callNextStep = () => {
    const damaged_parts = [];

    for (const key in state) {
      if (Object.prototype.hasOwnProperty.call(state, key)) {
        if (state[key]) {
          damaged_parts.push({ side: key });
        }
      }
    }
    updateSinisterBody({ crash: { ...sinister_body.crash, damaged_parts } });
    nextStep();
  };

  const isDisabled = () => {
    const check = Object.values(state).some((element) => element === true);
    return !check;
  };

  const { front, back, left, right, windshield } = state;

  return (
    <Grid container>
      <Grid container item lg={12}>
        <Box my={3}>
          <Typography
            variant="h6"
            color="textPrimary"
            style={{ fontFamily: 'Inter' }}
          >
            Indicanos lo que está dañado de tu vehículo
          </Typography>
        </Box>
      </Grid>

      <Grid container>
        <Grid item xs={6} md={4}>
          <Part
            title={'En el frente'}
            img={Front}
            checked={front}
            onChange={handleCheckboxChange('front')}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <Part
            title={'De atrás'}
            img={Back}
            checked={back}
            onChange={handleCheckboxChange('back')}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <Part
            title={'Del lado derecho'}
            img={Right}
            checked={right}
            onChange={handleCheckboxChange('right')}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <Part
            title={'Del lado izquierdo'}
            img={Left}
            checked={left}
            onChange={handleCheckboxChange('left')}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <Part
            title={'En el parabrisas'}
            img={Windshield}
            checked={windshield}
            onChange={handleCheckboxChange('windshield')}
          />
        </Grid>
      </Grid>
      <Grid container item lg={12} />
      <Grid container justify="center">
        <Grid item xs={12} sm={6}>
          <FloatingButton onClick={callNextStep} disabled={isDisabled()}>
            Continuar
          </FloatingButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TypeOfOwnDamage;
